import { fork, all } from 'redux-saga/effects'

import startStopRepeatSaga from './startStopRepeatSaga'

export default function* activitySaga() {
  yield all([fork(startStopRepeatSaga)])
}
